<template>
	<div class="warehouse-product-settings">
		<ModalHeader :title="getString('product_settings')" :button-text="getString('save')" @click-button="saveSettings" />
		<AppList :items="settingsItems">
			<template #quantity-dropdown="{item}">
				<div class="row centered space-between">
					<p class="list-item-title">{{ item.dropdownTitle }}</p>
					<AppNumberInput :value="product.affects_availability" :min="-1000000" :max="1000000" @changed-value="item.callbackQuantity" />
				</div>
			</template>
		</AppList>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import AppList from "@/shared/components/AppList.vue";
import AppButton from "@/shared/components/AppButton.vue";
import API from "@/shared/helpers/API";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const menuStore = useMenuStore();
		return {
			getString: languageStore.getString,
			userStore,
			notificationStore,
			menuStore,
		}
	},
	name: "WarehouseProductSettings",
	components: {AppNumberInput, AppButton, AppList, ModalHeader},
	emits: ['changed-product'],
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			settingsItems: [
				{
					title: this.getString('affects_availability'),
					switch: true,
					active: this.product.affects_availability !== null,
					dropdownSlot: 'quantity-dropdown',
					dropdownTitle: this.getString('threshold'),
					callbackQuantity: (v) => {
						this.product.affects_availability = v;
					},
					callback: (v) => {
						this.product.affects_availability = v ? 0 : null;
					},
				},
				{
					title: this.getString('delete'),
					buttonTitle: this.getString('delete'),
					callbackButton: this.deleteItem,
					buttonLoading: false,
				},
			]
		}
	},
	methods: {
		deleteItem() {
			API.init().deleteWarehouseItem(this.userStore.currBusinessId, this.product.menu_item_warehouse_id, r => {
				if(r && r.result === "OK") {
					this.notificationStore.showNotification("generic-success");

					if(this.menuStore.items) {
						let itemsWithSku = Object.values(this.menuStore.items).filter(i => i.sku === this.product.sku);
						itemsWithSku.forEach(i => {
							i.warehouse = false;
						});
						if(this.menuStore.modMenu && this.menuStore.modMenu.menu_id) {
							this.menuStore.changeModMenu(this.menuStore.modMenu.menu_id);
						}
					}
					this.$emit('changed-product');

				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});
		},
		saveSettings() {
			API.init().updateWarehouseItemSettings(this.userStore.currBusinessId, this.product.menu_item_warehouse_id, this.product.affects_availability, r => {

				if(r && r.result === "OK") {
					this.notificationStore.showNotification("generic-success");
					this.$emit('changed-product');
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">

</style>